export const MAIN_URL = 'http://158.101.166.74:8080/api/data/dima_litvinov/';
export const EVENTS = 'events';
export const MEMBERS = 'members';
export const dayLabel = ['Name', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri'];
export const timeLabel = ['10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00'];
export const message = {
  success: 'DONE!',
  failure: 'The slot is busy. Please select a different time or date.',
  noEvent: 'Invalid event name',
  noMember: 'Please select a participant',
  noDay: 'Please select the day of the event',
  noTime: 'Please select the time of the event',
  wrongName: 'Please type correct name',
  existName: 'Entered name already exists',
};
